/* ====== 画面表示メッセージ ===== */
export const screenDisplayMessage = (result,$1,$2,$3,$4,$5,$6,$7) => {
	// console.log(result)
	let message;
	if(result === undefined){
		message = 'データがありません。'
	}else{
		switch(result){
			case 'CMNI001': //登録確認
			message = `この内容でデータを登録します。問題なければ完了ボタンを押下してください。`; 
			break;
			case 'CMNI002': //更新確認
			message = `この内容でデータを更新します。問題なければ完了ボタンを押下してください。`; 
			break;
			case 'CMNI003': //削除確認
			message = `このデータを削除します。問題なければ完了ボタンを押下してください。`; 
			break;
			case 'CMNI004'://データの更新完了
			message = 'データの編集が完了しました。'
			break;
			case 'CMNI005'://データの削除完了
			message = 'データの削除が完了しました。'
			break;
			case 'CMNI006'://データの登録完了
			message = 'データの登録が完了しました。'
			break;
			case 'CMNI007'://担当するボタン押下
			message = '出力完了しました。'
			break;
			case 'CMNI008'://担当するボタン押下
			message = '従業員の一括更新が完了しました。'
			break;
			case 'CMNI009'://担当するボタン押下
			message = '部署マスタ情報の一括更新が完了しました。'
			break;
            /*その他*/
			default:
			message = 'データがありません。';
			break;
		}
	}
	return message;
};
/* 後で消す */
export const resultMessage = (result) =>{
	let message;
	if(result === undefined){
		message = 'データがありません。'
	}else{
		switch(result){
			
            /*その他*/
			default:
			message = 'データがありません。';
			break;
		}
	}
	return message;	
}
/* ====== ダイアログメッセージ ====== */  
export const dialogMessage = (result,$1,$2,$3,$4,$5,$6,$7) => {
	// console.log(result)
	let message;
	if(result === undefined){
		message = 'データがありません。'
	}else{
		switch(result){
			case 'CMNC001': //入力途中確認ダイアログ
			message = '入力途中のデータがあります。\n入力内容は破棄されますがよろしいですか？'; 
			break;
			case 'CMNC002': //エクセル出力確認ダイアログ
			message = `エクセル出力しますか？\n個人情報が含まれているため取り扱いには十分気をつけてください。`; 
			break;
			case 'IDHC007': //メール確認ダイアログ　廃止予定 🌟
			message = `${$1}のデータをコピーして登録しますか？\n[注意]登録する適用日よりも未来の適用日が登録されている場合、データは削除されます。`; 
			break;
			case 'CMNC003': //メール確認ダイアログ
			message = `コピーした適用開始日よりも前に適用開始日が設定されています。登録が完了した場合、コピーした適用開始日は削除されますがよろしいですか？`; 
			break;
			case 'CMNC004': //
			message = `検索が解除されますがよろしいですか？`; 
			break;
			case 'CMNC005': //ログアウト確認
			message = `ログアウトします。よろしいですか？`; 
			break;
            /*その他*/
			default:
			message = 'データがありません。';
			break;
		}
	}
	return message;
};



/* ====== スナックバーメッセージ ====== */
export const snackbarMessage = (result,$1,$2,$3,$4,$5,$6,$7) => {
	let message;
	if(result === undefined){
		message = 'データがありません。'
	}else{
		switch(result){
            case 'CMNW001'://今日よりも前に適用開始日を登録しようとした
			message = '過去に適用開始日を登録できません。';
			break;
            case 'CMNW002'://デフォルトなしで権限グループ登録した
			message = 'デフォルト値が存在しません。権限グループコード000を追加してください。';
			break;
			case 'CMNW003'://権限をチェックした時に一つもない権限グループはエラー
			message = '権限は一つ以上選択してください。';
			break;
            case 'CMNW004'://変更せずに更新処理をしようとした
			message = '変更箇所がありません。データを変更後確認ボタンを押してください。';
			break;
			//IDまだない🌟
            case 'CMNW005'://データ重複
			message = 'データが重複しています。入力データを確認してください。';
			break;
			//IDまだない🌟
			case 'CMNW006'://既に登録されている適用開始日で登録しようとした
			message = '既に登録されている適用開始日です。';
			break;
            /*その他*/
			default:
			message = 'データがありません。';
			break;

		}
	}
	return message;		
};
export const snackbarApiErrorMessage = (result,$1,$2,$3,$4,$5,$6,$7) => {
	let message;//snackbar用メッセージ
	if (result.responseData === undefined) {
		message = 'ネットワークに繋がっていない、もしくはサーバーに問題が発生しました。';
	} else {
		switch (result.responseData.status) {
			case 401://認証失敗(共通)  CMNE010
				message = `APIエラーが発生しました。管理者に問い合わせてください。${result.responseData.status}`;
				break;
			case 404://存在しないパス(共通)  CMNE011
				message = `APIエラーが発生しました。管理者に問い合わせてください。${result.responseData.status}`;
				break;
			case 400:
				switch (result?.responseData?.data?.error?.code) {
					case '200001': //JSONパースエラー  CMNE012
						message =  `入力されたデータの形式が不正です。\n管理者に問い合わせてください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`; 
						break;
                    case '200002': //バリデーションエラー  CMNE013
                        message =  `入力されたデータの形式が不正です。\n管理者に問い合わせてください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`; 
                        break;
                    case '200003': //デコードエラー  CMNE024
                        message =  `デコードに失敗しました。\n管理者に問い合わせてください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`; 
                        break;
                    case '200004'://レスポンスオーバーエラー  CMNE014
                        message = `取得件数が多いため検索項目を絞ってください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`;
                        break;
                    case '200005': //操作対象のリソースが存在しない、不正なリクエストキー  CMNE23
                        message =  `該当データがありません。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`; 
                        break;
					case '232001'://リクエスト不整合(検索文字が6個以上)  CMNE15
						message = `検索文字は5つ以内で入力してください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`;
						break;
                    case '232002'://リクエスト不整合（リクエストされた日付=DB上に存在する日付) CMNE17
                        message = `既に同じ日付やコードが登録されています。異なる値を登録してください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`;
                        break;
					case '232003'://リクエスト不整合（リクエストされた日付=DB上に存在する日付) CMNE027
						message = `部署と兼務部署に同じデータが入力されています。異なるデータを登録してください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`;
						break;
                    case '200006'://不正なリクエストデータ　CMNE022
                        message = `入力されたデータが不正です。正しいデータを登録してください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`;
                        break;
                    case '200007'://不正なリクエストデータ　CMNE023
                        message = `適用開始日が複数登録されています。正しいデータを登録してください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`;
                        break;
					case '200008'://不正なリクエストデータ　CMNE024
                        message = `入力されたデータが不正です。正しいデータを登録してください。(${result.responseData.status ? result.responseData.status : ''}${result.responseData.data.error.code})`;
                        break;
					default:  //その他
						message = `内部エラーが発生しました。管理者に問い合わせてください。(${result.responseData.status ? result.responseData.status : ''}${result?.responseData?.data?.error?.code?` ${result.responseData.data.error.code}`:''})`;
				}
				break;
			case 412://排他エラー(共通)  CMNE025
				message = `内部エラーが発生しました。管理者に問い合わせてください。(${result.responseData.status})`;
				break;
			case 500://サーバー内部エラー(共通)  CMNE025
				message = `ネットワークに繋がっていない、もしくはサーバーに問題が発生しました。${result.responseData.status}`;
				break;
			default://その他
				message = `内部エラーが発生しました。管理者に問い合わせてください。(${result.responseData.status})`;
		};
	};
	return message;
};

